// AUTO-GENERATED by scripts/gen-motion.mjs from
// packages/ui-tokens/scripts/motion-physics.mjs — do not edit.

/**
 * The ballistic model behind `KunShatter`, as data — outward impulse, air
 * drag (`1 − (1−t)^dragExponent`), gravity as a t² acceleration — sampled
 * into `keyframeSteps` linear keyframes per shard. The same manifest
 * generates `KunShatterPhysics` in the kun_ui_tokens pub package, so the
 * web and Flutter renditions of the motion cannot drift. Tune the feel in
 * the manifest, never inline in a component.
 */
export const KUN_SHATTER_PHYSICS = {
  keyframeSteps: 16,
  reachFactor: 0.5,
  launchMin: 0.32,
  launchSpan: 0.55,
  verticalFactor: 0.8,
  gravityMin: 0.85,
  gravitySpan: 0.5,
  dragExponent: 1.7,
  scaleEndMin: 0.8,
  scaleEndSpan: 0.16,
  fadeOutStartMin: 0.5,
  fadeOutStartSpan: 0.18,
  settleExponent: 2,
  fadeInWindow: 0.4,
  staggerFraction: 0.22,
  staggerCapMs: 120,
  defaultDurationMs: 1100,
  defaultRotationDeg: 140,
} as const

/**
 * Drag-to-dismiss on a bottom sheet, as data: dismiss on release when the
 * sheet moved down and either the release velocity exceeds `closeVelocity`
 * (px/ms) or the offset reaches `closeDistanceRatio` of the panel height
 * (capped at the viewport); an upward drag of d px moves the panel
 * `rubberBandLimit × (1 − e^(−d / rubberBandLimit))`. The same manifest
 * generates `KunSwipeDismissPhysics` in kun_ui_tokens.
 */
export const KUN_SWIPE_DISMISS_PHYSICS = {
  closeDistanceRatio: 0.25,
  closeVelocity: 0.4,
  rubberBandLimit: 32,
} as const
